'use strict'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import store from '@/store'
import router from './router'
import VuejsDialog from 'vuejs-dialog'
import VueCookies from 'vue-cookies'
import VeeValidate from 'vee-validate'
import VueBrowserUpdate from 'vue-browserupdate'
/* required for vuejs-dialog v1.3.0 */
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import { setTimeout } from 'timers'
import BasePageComponent from '@/components/BasePageComponent'

Vue.component('base-page-component', BasePageComponent)

const scriptLoader = {
  loaded: [],
  load (src, check) {
    var self = this
    return new Promise((resolve, reject) => {
      setTimeout(function () {
        reject(new Error('timeout'))
      }, 5000)

      if (check === true && self.loaded.indexOf(src) !== -1) {
        resolve(undefined)
      } else {
        self.loaded.push(src)
        if (document) {
          const script = document.createElement('script')
          script.onload = function () {
            resolve(true)
          }
          script.setAttribute('src', src)
          document.head.appendChild(script)
        }
      }
    })
  }
}

const errorExtractor = {
  get (message, error) {
    var newErrMsg = message + '\n'
    if (error !== undefined && error !== null && error.response !== undefined && error.response.statusText !== undefined) {
      newErrMsg = newErrMsg + error.response.statusText
    } else {
      newErrMsg = newErrMsg + error
    }
    return newErrMsg
  }
}

Vue.use({
  install () {
    Vue.prototype.$scriptLoader = scriptLoader
  }
})
Vue.use({
  install () {
    Vue.prototype.$errorExtractor = errorExtractor
  }
})
Vue.use(VueCookies)

const config = {
  aria: true,
  classNames: {},
  classes: false,
  delay: 0,
  dictionary: null,
  errorBagName: 'validateErrors', // change if property conflicts
  events: 'input|blur',
  fieldsBagName: 'validateFields',
  i18n: null, // the vue-i18n plugin instance
  i18nRootKey: 'validations', // the nested key under which the validation messages will be located
  inject: true,
  locale: 'en',
  strict: true,
  validity: false
}
Vue.use(VeeValidate, config)
Vue.use(BootstrapVue)
Vue.use(VuejsDialog)
// https://www.npmjs.com/package/vue-browserupdate
// http://browser-update.org/customize.html
Vue.use(VueBrowserUpdate, {
  options: {
    required: { i: 11 },
    reminder: 0
  },
  shift_page_down: true
})

router.beforeEach((to, from, next) => {
  var currentRole = store.state.currentRole
  var passwordChangeRequired = store.state.passwordChangeRequired
  var allowedRouteNames = ['My Profile', 'logout', 'login'].map(function (currentValue, index, array) { return currentValue.toLowerCase() })

  if (passwordChangeRequired && document.cookie.indexOf('.jwt=') === -1) {
    store.commit('LOGOUT_USER')
    passwordChangeRequired = false
  }

  if (document.cookie.indexOf('.jwt=') === -1 && to.name.indexOf('login') === -1) {
    next('/login')
    return
  }

  if (passwordChangeRequired && allowedRouteNames.indexOf(to.name.toLowerCase()) === -1) {
    next(false)
    alert('You have to change your password before you continue to use this application.')
  } else {
    if (to.meta !== undefined && to.meta.roles !== undefined && to.meta.roles.indexOf(currentRole) === -1) {
      alert('Access denied')
      next(false)
    } else {
      next()
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  beforeCreate () {
    if (!this.$cookies.isKey('.jwt')) {
      store.commit('LOGOUT_USER')
      router.push('/login')
    }
  },
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js